// extracted by mini-css-extract-plugin
export default {"root":"J3cJ3PzlLrvfkaBMlamy"};